import { render, staticRenderFns } from "./data-complement-add.vue?vue&type=template&id=66dc7840&scoped=true&"
import script from "./data-complement-add.vue?vue&type=script&lang=js&"
export * from "./data-complement-add.vue?vue&type=script&lang=js&"
import style0 from "./data-complement-add.vue?vue&type=style&index=0&id=66dc7840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc7840",
  null
  
)

export default component.exports